module.exports = __webpack_public_path__ + "img/6.8b8988dc.png";